// Mock Data for EWHRDN Membership System
// This file contains sample data for testing and demonstration

export const mockUsers = [
  {
    id: 1,
    username: 'admin',
    email: 'admin@ewhrdn.org',
    first_name: 'Alemitu',
    last_name: 'Kebede',
    role: 'system_admin',
    region: 'Addis Ababa',
    is_active: true,
    created_at: '2023-01-15T08:00:00Z',
    last_login: '2024-01-20T14:30:00Z'
  },
  {
    id: 2,
    username: 'coordinator',
    email: 'coordinator@ewhrdn.org',
    first_name: 'Meseret',
    last_name: 'Tesfaye',
    role: 'regional_coordinator',
    region: 'Oromia',
    is_active: true,
    created_at: '2023-02-10T09:15:00Z',
    last_login: '2024-01-19T16:45:00Z'
  },
  {
    id: 3,
    username: 'dataentry',
    email: 'dataentry@ewhrdn.org',
    first_name: 'Hirut',
    last_name: 'Mengistu',
    role: 'data_entry_officer',
    region: 'Amhara',
    is_active: true,
    created_at: '2023-03-05T10:30:00Z',
    last_login: '2024-01-18T11:20:00Z'
  },
  {
    id: 4,
    username: 'program',
    email: 'program@ewhrdn.org',
    first_name: 'Tigist',
    last_name: 'Assefa',
    role: 'program_officer',
    region: 'Addis Ababa',
    is_active: true,
    created_at: '2023-04-12T07:45:00Z',
    last_login: '2024-01-20T09:15:00Z'
  },
  {
    id: 5,
    username: 'superadmin',
    email: 'superadmin@ewhrdn.org',
    first_name: 'Eleni',
    last_name: 'Girma',
    role: 'super_admin',
    region: 'Addis Ababa',
    is_active: true,
    created_at: '2023-01-01T00:00:00Z',
    last_login: '2024-01-20T17:00:00Z'
  }
];

export const mockRegions = [
  { id: 1, name: 'Addis Ababa', code: 'AA', description: 'Capital city' },
  { id: 2, name: 'Afar', code: 'AF', description: 'Afar Regional State' },
  { id: 3, name: 'Amhara', code: 'AM', description: 'Amhara Regional State' },
  { id: 4, name: 'Benishangul-Gumuz', code: 'BG', description: 'Benishangul-Gumuz Regional State' },
  { id: 5, name: 'Dire Dawa', code: 'DD', description: 'Dire Dawa City Administration' },
  { id: 6, name: 'Gambela', code: 'GA', description: 'Gambela Regional State' },
  { id: 7, name: 'Harari', code: 'HA', description: 'Harari Regional State' },
  { id: 8, name: 'Oromia', code: 'OR', description: 'Oromia Regional State' },
  { id: 9, name: 'Sidama', code: 'SI', description: 'Sidama Regional State' },
  { id: 10, name: 'Somali', code: 'SO', description: 'Somali Regional State' },
  { id: 11, name: 'SNNPR', code: 'SN', description: 'Southern Nations, Nationalities, and Peoples Region' },
  { id: 12, name: 'Tigray', code: 'TI', description: 'Tigray Regional State' }
];

export const mockMemberCategories = [
  { id: 1, name: 'Individual WHRD', description: 'Individual women human rights defenders' },
  { id: 2, name: 'CSO Representative', description: 'Representatives from civil society organizations' },
  { id: 3, name: 'Legal Professional', description: 'Lawyers and legal professionals' },
  { id: 4, name: 'Journalist/Media', description: 'Media professionals and journalists' },
  { id: 5, name: 'Academic/Researcher', description: 'Academics and researchers' },
  { id: 6, name: 'Government Official', description: 'Government officials working on human rights' },
  { id: 7, name: 'Community Leader', description: 'Community leaders and activists' },
  { id: 8, name: 'Student', description: 'Students studying human rights or related fields' }
];

export const mockMembers = [
  {
    id: 1,
    member_id: 'EWHRDN-001',
    first_name: 'Aster',
    last_name: 'Gebremedhin',
    middle_name: 'Tadesse',
    date_of_birth: '1985-03-15',
    gender: 'female',
    email: 'aster.g@email.com',
    phone: '+251911234567',
    alternate_phone: '+251911234568',
    region_id: 1,
    zone: 'Addis Ababa',
    woreda: 'Kirkos',
    kebele: 'Kebele 01',
    house_number: 'H-123',
    postal_code: '1000',
    occupation: 'Human Rights Lawyer',
    organization_name: 'Ethiopian Women Lawyers Association',
    organization_type: 'cso',
    position_title: 'Senior Legal Advisor',
    years_of_experience: 12,
    member_category_id: 3,
    membership_type: 'individual',
    membership_status: 'active',
    membership_date: '2021-06-15',
    membership_expiry_date: '2025-06-15',
    thematic_areas: ['women_rights', 'legal_aid', 'gender_based_violence'],
    languages_spoken: ['amharic', 'english', 'oromo'],
    emergency_contact_name: 'Tadesse Gebremedhin',
    emergency_contact_phone: '+251911234569',
    emergency_contact_relationship: 'Husband',
    approval_status: 'approved',
    created_at: '2021-06-15T10:00:00Z',
    created_by: 1
  },
  {
    id: 2,
    member_id: 'EWHRDN-002',
    first_name: 'Meron',
    last_name: 'Teshome',
    middle_name: 'Kebede',
    date_of_birth: '1990-07-22',
    gender: 'female',
    email: 'meron.t@email.com',
    phone: '+251922345678',
    region_id: 8,
    zone: 'West Shewa',
    woreda: 'Ambo',
    kebele: 'Kebele 05',
    house_number: 'H-456',
    occupation: 'Journalist',
    organization_name: 'Ethiopian Broadcasting Corporation',
    organization_type: 'government',
    position_title: 'Senior Reporter',
    years_of_experience: 8,
    member_category_id: 4,
    membership_type: 'individual',
    membership_status: 'active',
    membership_date: '2021-08-20',
    membership_expiry_date: '2025-08-20',
    thematic_areas: ['media_rights', 'freedom_of_expression', 'women_rights'],
    languages_spoken: ['amharic', 'english', 'oromo'],
    emergency_contact_name: 'Kebede Teshome',
    emergency_contact_phone: '+251922345679',
    emergency_contact_relationship: 'Father',
    approval_status: 'approved',
    created_at: '2021-08-20T14:30:00Z',
    created_by: 2
  },
  {
    id: 3,
    member_id: 'EWHRDN-003',
    first_name: 'Hanan',
    last_name: 'Mohammed',
    middle_name: 'Ibrahim',
    date_of_birth: '1988-11-10',
    gender: 'female',
    email: 'hanan.m@email.com',
    phone: '+251933456789',
    region_id: 10,
    zone: 'Jijiga',
    woreda: 'Jijiga',
    kebele: 'Kebele 03',
    house_number: 'H-789',
    occupation: 'Community Development Worker',
    organization_name: 'Somali Women Development Association',
    organization_type: 'cso',
    position_title: 'Program Coordinator',
    years_of_experience: 10,
    member_category_id: 2,
    membership_type: 'individual',
    membership_status: 'active',
    membership_date: '2022-01-15',
    membership_expiry_date: '2026-01-15',
    thematic_areas: ['community_development', 'women_empowerment', 'child_protection'],
    languages_spoken: ['somali', 'amharic', 'english'],
    emergency_contact_name: 'Ibrahim Mohammed',
    emergency_contact_phone: '+251933456790',
    emergency_contact_relationship: 'Brother',
    approval_status: 'approved',
    created_at: '2022-01-15T09:15:00Z',
    created_by: 2
  },
  {
    id: 4,
    member_id: 'EWHRDN-004',
    first_name: 'Tigist',
    last_name: 'Assefa',
    middle_name: 'Girma',
    date_of_birth: '1992-05-18',
    gender: 'female',
    email: 'tigist.a@email.com',
    phone: '+251944567890',
    region_id: 3,
    zone: 'North Shewa',
    woreda: 'Debre Berhan',
    kebele: 'Kebele 02',
    house_number: 'H-321',
    occupation: 'Student',
    organization_name: 'Addis Ababa University',
    organization_type: 'academic',
    position_title: 'Graduate Student',
    years_of_experience: 2,
    member_category_id: 8,
    membership_type: 'individual',
    membership_status: 'active',
    membership_date: '2022-09-10',
    membership_expiry_date: '2026-09-10',
    thematic_areas: ['academic_research', 'women_rights', 'youth_empowerment'],
    languages_spoken: ['amharic', 'english'],
    emergency_contact_name: 'Girma Assefa',
    emergency_contact_phone: '+251944567891',
    emergency_contact_relationship: 'Father',
    approval_status: 'approved',
    created_at: '2022-09-10T11:45:00Z',
    created_by: 3
  },
  {
    id: 5,
    member_id: 'EWHRDN-005',
    first_name: 'Zenebech',
    last_name: 'Worku',
    middle_name: 'Tadesse',
    date_of_birth: '1983-12-03',
    gender: 'female',
    email: 'zenebech.w@email.com',
    phone: '+251955678901',
    region_id: 11,
    zone: 'Gurage',
    woreda: 'Wolkite',
    kebele: 'Kebele 04',
    house_number: 'H-654',
    occupation: 'Government Official',
    organization_name: 'Ministry of Women, Children and Youth',
    organization_type: 'government',
    position_title: 'Gender Specialist',
    years_of_experience: 15,
    member_category_id: 6,
    membership_type: 'individual',
    membership_status: 'active',
    membership_date: '2021-11-25',
    membership_expiry_date: '2025-11-25',
    thematic_areas: ['gender_equality', 'policy_advocacy', 'women_rights'],
    languages_spoken: ['amharic', 'english', 'gurage'],
    emergency_contact_name: 'Tadesse Worku',
    emergency_contact_phone: '+251955678902',
    emergency_contact_relationship: 'Husband',
    approval_status: 'approved',
    created_at: '2021-11-25T13:20:00Z',
    created_by: 1
  },
  {
    id: 6,
    member_id: 'EWHRDN-006',
    first_name: 'Fatuma',
    last_name: 'Ahmed',
    middle_name: 'Ali',
    date_of_birth: '1987-08-14',
    gender: 'female',
    email: 'fatuma.a@email.com',
    phone: '+251966789012',
    region_id: 2,
    zone: 'Zone 1',
    woreda: 'Asayita',
    kebele: 'Kebele 01',
    house_number: 'H-987',
    occupation: 'Community Leader',
    organization_name: 'Afar Women Association',
    organization_type: 'cso',
    position_title: 'President',
    years_of_experience: 12,
    member_category_id: 7,
    membership_type: 'individual',
    membership_status: 'pending',
    membership_date: '2023-03-15',
    membership_expiry_date: '2027-03-15',
    thematic_areas: ['community_leadership', 'women_empowerment', 'cultural_rights'],
    languages_spoken: ['afar', 'amharic', 'english'],
    emergency_contact_name: 'Ali Ahmed',
    emergency_contact_phone: '+251966789013',
    emergency_contact_relationship: 'Brother',
    approval_status: 'regional_pending',
    created_at: '2023-03-15T16:30:00Z',
    created_by: 3
  },
  {
    id: 7,
    member_id: 'EWHRDN-007',
    first_name: 'Meskerem',
    last_name: 'Bekele',
    middle_name: 'Tadesse',
    date_of_birth: '1995-02-28',
    gender: 'female',
    email: 'meskerem.b@email.com',
    phone: '+251977890123',
    region_id: 9,
    zone: 'Sidama',
    woreda: 'Hawassa',
    kebele: 'Kebele 06',
    house_number: 'H-147',
    occupation: 'Social Worker',
    organization_name: 'Sidama Women Development Organization',
    organization_type: 'cso',
    position_title: 'Program Officer',
    years_of_experience: 5,
    member_category_id: 2,
    membership_type: 'individual',
    membership_status: 'active',
    membership_date: '2022-06-20',
    membership_expiry_date: '2026-06-20',
    thematic_areas: ['social_work', 'women_rights', 'mental_health'],
    languages_spoken: ['sidama', 'amharic', 'english'],
    emergency_contact_name: 'Tadesse Bekele',
    emergency_contact_phone: '+251977890124',
    emergency_contact_relationship: 'Father',
    approval_status: 'approved',
    created_at: '2022-06-20T12:15:00Z',
    created_by: 2
  },
  {
    id: 8,
    member_id: 'EWHRDN-008',
    first_name: 'Alemitu',
    last_name: 'Kebede',
    middle_name: 'Girma',
    date_of_birth: '1980-09-05',
    gender: 'female',
    email: 'alemitu.k@email.com',
    phone: '+251988901234',
    region_id: 12,
    zone: 'Central Tigray',
    woreda: 'Mekelle',
    kebele: 'Kebele 08',
    house_number: 'H-258',
    occupation: 'Academic',
    organization_name: 'Mekelle University',
    organization_type: 'academic',
    position_title: 'Associate Professor',
    years_of_experience: 18,
    member_category_id: 5,
    membership_type: 'individual',
    membership_status: 'active',
    membership_date: '2021-04-10',
    membership_expiry_date: '2025-04-10',
    thematic_areas: ['academic_research', 'gender_studies', 'women_rights'],
    languages_spoken: ['tigrinya', 'amharic', 'english'],
    emergency_contact_name: 'Girma Kebede',
    emergency_contact_phone: '+251988901235',
    emergency_contact_relationship: 'Husband',
    approval_status: 'approved',
    created_at: '2021-04-10T08:45:00Z',
    created_by: 1
  }
];

export const mockTrainingPrograms = [
  {
    id: 1,
    title: 'Women Human Rights Advocacy Training',
    description: 'Comprehensive training on women human rights advocacy strategies and techniques.',
    training_type: 'workshop',
    duration_hours: 40,
    start_date: '2024-02-15',
    end_date: '2024-02-19',
    location: 'Addis Ababa, Ethiopia',
    trainer_name: 'Dr. Aster Gebremedhin',
    trainer_organization: 'Ethiopian Women Lawyers Association',
    max_participants: 25,
    cost_per_participant: 0,
    is_active: true,
    created_at: '2024-01-15T10:00:00Z',
    created_by: 1
  },
  {
    id: 2,
    title: 'Digital Security for Women Human Rights Defenders',
    description: 'Training on digital security practices and tools for women human rights defenders.',
    training_type: 'online_course',
    duration_hours: 20,
    start_date: '2024-03-01',
    end_date: '2024-03-15',
    location: 'Online',
    trainer_name: 'Tech for Good Ethiopia',
    trainer_organization: 'Tech for Good Ethiopia',
    max_participants: 50,
    cost_per_participant: 0,
    is_active: true,
    created_at: '2024-01-20T14:30:00Z',
    created_by: 4
  },
  {
    id: 3,
    title: 'Gender-Based Violence Prevention and Response',
    description: 'Training on preventing and responding to gender-based violence in communities.',
    training_type: 'seminar',
    duration_hours: 16,
    start_date: '2024-04-10',
    end_date: '2024-04-12',
    location: 'Hawassa, Ethiopia',
    trainer_name: 'Meskerem Bekele',
    trainer_organization: 'Sidama Women Development Organization',
    max_participants: 30,
    cost_per_participant: 0,
    is_active: true,
    created_at: '2024-02-01T09:15:00Z',
    created_by: 2
  },
  {
    id: 4,
    title: 'Legal Aid and Paralegal Training',
    description: 'Training on providing legal aid and paralegal services to women in need.',
    training_type: 'workshop',
    duration_hours: 32,
    start_date: '2024-05-20',
    end_date: '2024-05-24',
    location: 'Bahir Dar, Ethiopia',
    trainer_name: 'Legal Aid Ethiopia',
    trainer_organization: 'Legal Aid Ethiopia',
    max_participants: 20,
    cost_per_participant: 0,
    is_active: true,
    created_at: '2024-02-15T11:45:00Z',
    created_by: 1
  }
];

export const mockEvents = [
  {
    id: 1,
    title: 'International Women\'s Day Celebration',
    description: 'Annual celebration of International Women\'s Day with panel discussions and networking.',
    event_type: 'conference',
    start_date: '2024-03-08',
    end_date: '2024-03-08',
    location: 'Addis Ababa, Ethiopia',
    organizer: 'EWHRDN',
    max_participants: 200,
    registration_deadline: '2024-03-01',
    is_active: true,
    created_at: '2024-01-10T08:00:00Z',
    created_by: 1
  },
  {
    id: 2,
    title: 'Regional Women Human Rights Defenders Meeting',
    description: 'Quarterly meeting for regional coordinators and key stakeholders.',
    event_type: 'meeting',
    start_date: '2024-04-15',
    end_date: '2024-04-16',
    location: 'Hawassa, Ethiopia',
    organizer: 'EWHRDN Regional Office',
    max_participants: 50,
    registration_deadline: '2024-04-01',
    is_active: true,
    created_at: '2024-02-01T10:30:00Z',
    created_by: 2
  },
  {
    id: 3,
    title: 'Youth Women Leaders Summit',
    description: 'Empowering young women leaders in human rights advocacy.',
    event_type: 'conference',
    start_date: '2024-06-20',
    end_date: '2024-06-22',
    location: 'Mekelle, Ethiopia',
    organizer: 'EWHRDN Youth Network',
    max_participants: 100,
    registration_deadline: '2024-05-20',
    is_active: true,
    created_at: '2024-03-01T14:15:00Z',
    created_by: 4
  }
];

export const mockMemberTrainings = [
  {
    id: 1,
    member_id: 1,
    training_program_id: 1,
    attendance_status: 'completed',
    attendance_percentage: 100,
    completion_date: '2024-02-19',
    certificate_url: '/certificates/EWHRDN-001-training-1.pdf',
    feedback: 'Excellent training program. Very informative and practical.',
    grade: 'A+',
    created_at: '2024-02-15T09:00:00Z',
    created_by: 1
  },
  {
    id: 2,
    member_id: 2,
    training_program_id: 1,
    attendance_status: 'completed',
    attendance_percentage: 95,
    completion_date: '2024-02-19',
    certificate_url: '/certificates/EWHRDN-002-training-1.pdf',
    feedback: 'Great learning experience. Would recommend to others.',
    grade: 'A',
    created_at: '2024-02-15T09:00:00Z',
    created_by: 1
  },
  {
    id: 3,
    member_id: 3,
    training_program_id: 2,
    attendance_status: 'completed',
    attendance_percentage: 100,
    completion_date: '2024-03-15',
    certificate_url: '/certificates/EWHRDN-003-training-2.pdf',
    feedback: 'Very useful for our digital security needs.',
    grade: 'A+',
    created_at: '2024-03-01T10:00:00Z',
    created_by: 4
  },
  {
    id: 4,
    member_id: 4,
    training_program_id: 2,
    attendance_status: 'completed',
    attendance_percentage: 90,
    completion_date: '2024-03-15',
    certificate_url: '/certificates/EWHRDN-004-training-2.pdf',
    feedback: 'Good introduction to digital security concepts.',
    grade: 'B+',
    created_at: '2024-03-01T10:00:00Z',
    created_by: 4
  }
];

export const mockMemberEvents = [
  {
    id: 1,
    member_id: 1,
    event_id: 1,
    participation_status: 'attended',
    feedback: 'Great event with valuable networking opportunities.',
    created_at: '2024-03-08T08:00:00Z',
    created_by: 1
  },
  {
    id: 2,
    member_id: 2,
    event_id: 1,
    participation_status: 'attended',
    feedback: 'Inspiring speakers and meaningful discussions.',
    created_at: '2024-03-08T08:00:00Z',
    created_by: 1
  },
  {
    id: 3,
    member_id: 3,
    event_id: 2,
    participation_status: 'attended',
    feedback: 'Productive regional coordination meeting.',
    created_at: '2024-04-15T09:00:00Z',
    created_by: 2
  },
  {
    id: 4,
    member_id: 4,
    event_id: 3,
    participation_status: 'registered',
    feedback: null,
    created_at: '2024-06-01T10:00:00Z',
    created_by: 4
  }
];

export const mockNotifications = [
  {
    id: 1,
    user_id: 1,
    title: 'New Member Registration',
    message: 'A new member has registered and requires approval.',
    notification_type: 'info',
    is_read: false,
    related_table: 'members',
    related_id: 6,
    created_at: '2024-01-20T10:30:00Z'
  },
  {
    id: 2,
    user_id: 2,
    title: 'Training Program Completed',
    message: 'Member EWHRDN-001 has completed the Women Human Rights Advocacy Training.',
    notification_type: 'success',
    is_read: false,
    related_table: 'member_trainings',
    related_id: 1,
    created_at: '2024-02-19T16:45:00Z'
  },
  {
    id: 3,
    user_id: 3,
    title: 'Event Registration',
    message: 'Member EWHRDN-004 has registered for the Youth Women Leaders Summit.',
    notification_type: 'info',
    is_read: true,
    related_table: 'member_events',
    related_id: 4,
    created_at: '2024-06-01T10:00:00Z'
  }
];

export const mockSystemSettings = [
  {
    id: 1,
    setting_key: 'member_id_prefix',
    setting_value: 'EWHRDN',
    description: 'Prefix for member ID generation',
    updated_at: '2024-01-01T00:00:00Z',
    updated_by: 1
  },
  {
    id: 2,
    setting_key: 'membership_duration_years',
    setting_value: '2',
    description: 'Default membership duration in years',
    updated_at: '2024-01-01T00:00:00Z',
    updated_by: 1
  },
  {
    id: 3,
    setting_key: 'max_file_upload_size',
    setting_value: '10485760',
    description: 'Maximum file upload size in bytes (10MB)',
    updated_at: '2024-01-01T00:00:00Z',
    updated_by: 1
  },
  {
    id: 4,
    setting_key: 'backup_frequency_days',
    setting_value: '7',
    description: 'Database backup frequency in days',
    updated_at: '2024-01-01T00:00:00Z',
    updated_by: 1
  },
  {
    id: 5,
    setting_key: 'session_timeout_minutes',
    setting_value: '480',
    description: 'User session timeout in minutes (8 hours)',
    updated_at: '2024-01-01T00:00:00Z',
    updated_by: 1
  }
];

// Dashboard statistics
export const mockDashboardStats = {
  totalMembers: 8,
  activeMembers: 7,
  pendingMembers: 1,
  totalTrainings: 4,
  completedTrainings: 4,
  totalEvents: 3,
  upcomingEvents: 1,
  regionalDistribution: [
    { region: 'Addis Ababa', count: 2 },
    { region: 'Oromia', count: 1 },
    { region: 'Somali', count: 1 },
    { region: 'Amhara', count: 1 },
    { region: 'SNNPR', count: 1 },
    { region: 'Afar', count: 1 },
    { region: 'Sidama', count: 1 },
    { region: 'Tigray', count: 1 }
  ],
  membershipByCategory: [
    { category: 'Individual WHRD', count: 3 },
    { category: 'CSO Representative', count: 2 },
    { category: 'Legal Professional', count: 1 },
    { category: 'Journalist/Media', count: 1 },
    { category: 'Academic/Researcher', count: 1 },
    { category: 'Government Official', count: 1 },
    { category: 'Community Leader', count: 1 },
    { category: 'Student', count: 1 }
  ],
  recentActivities: [
    {
      id: 1,
      type: 'member_registration',
      description: 'New member Fatuma Ahmed registered',
      timestamp: '2024-01-20T10:30:00Z',
      user: 'Hirut Mengistu'
    },
    {
      id: 2,
      type: 'training_completion',
      description: 'Aster Gebremedhin completed Women Human Rights Advocacy Training',
      timestamp: '2024-02-19T16:45:00Z',
      user: 'System'
    },
    {
      id: 3,
      type: 'event_registration',
      description: 'Tigist Assefa registered for Youth Women Leaders Summit',
      timestamp: '2024-06-01T10:00:00Z',
      user: 'Tigist Assefa'
    }
  ]
};

export default {
  mockUsers,
  mockRegions,
  mockMemberCategories,
  mockMembers,
  mockTrainingPrograms,
  mockEvents,
  mockMemberTrainings,
  mockMemberEvents,
  mockNotifications,
  mockSystemSettings,
  mockDashboardStats
};

